// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
@keyframes pill-module__spin___QcfMa {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.pill-module__pill___HvBPl {
  background: var(--primary600, #4b286d);
  display: inline-block;
  padding: 7px 15px 8px;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 600;
}
.pill-module__pill___HvBPl svg {
  fill: var(--surface1, #fff);
  stroke: var(--surface1, #fff);
}
.pill-module__pill--round___Dbavy {
  border-radius: 21px;
}
.pill-module__pill--large___Frv60 {
  font-size: 1rem;
}
.pill-module__pill--medium___qeV_2 {
  font-size: 0.875rem;
}
.pill-module__pill--padded___uRqRv {
  padding-left: 30px;
  padding-right: 30px;
}
.pill-module__pill--clickable___ue3SA {
  cursor: pointer;
}
.pill-module__pill--clickable___ue3SA:hover {
  background: var(--primary700, #371e47);
}
.pill-module__pill--outline___aUVll {
  background: var(--surface1, #fff);
  border: solid 1px var(--neutral15);
}
.pill-module__pill--outline___aUVll svg {
  fill: var(--neutral100, #2c2e30);
  stroke: var(--neutral100, #2c2e30);
}
.pill-module__pill--outline___aUVll:hover.pill-module__pill--clickable___ue3SA {
  background: var(--primary50, #f2eff4);
  border: solid 2px var(--primary600, #4b286d);
}
.pill-module__pill--negative___pIav7 {
  background: var(--surface1, #fff);
}
.pill-module__pill--negative___pIav7 svg {
  fill: var(--primary600, #4b286d);
  stroke: var(--primary600, #4b286d);
}
.pill-module__pill--negative___pIav7:hover.pill-module__pill--clickable___ue3SA {
  background: var(--neutral15);
}
.pill-module__pill--outline-white___f7vm8 {
  background: none;
  border: solid 2px var(--surface1, #fff);
}
.pill-module__pill--outline-white___f7vm8 svg {
  fill: var(--surface1, #fff);
  stroke: var(--surface1, #fff);
}
.pill-module__pill--outline-white___f7vm8:hover.pill-module__pill--clickable___ue3SA {
  background: var(--surface1, #fff);
}
.pill-module__pill--outline-white___f7vm8:hover.pill-module__pill--clickable___ue3SA .pill-module__label___Eh_fB {
  color: var(--primary600, #4b286d);
}
.pill-module__pill--outline-blue___ns8Ky {
  background: var(--surface1, #fff);
  border: solid 1px var(--neutral15);
}
.pill-module__pill--outline-blue___ns8Ky svg {
  fill: var(--primary600, #4b286d);
  stroke: var(--primary600, #4b286d);
}
.pill-module__pill--outline-blue___ns8Ky:hover.pill-module__pill--clickable___ue3SA {
  background: var(--primary50, #f2eff4);
  border: solid 2px var(--primary600, #4b286d);
}
.pill-module__pill--secondary____gqHd {
  background: var(--surface1, #fff);
  box-shadow: inset 0px 0px 0px 2px var(--primary600, #4b286d);
}
.pill-module__pill--secondary____gqHd svg {
  fill: var(--neutral100, #2c2e30);
  stroke: var(--neutral100, #2c2e30);
}
.pill-module__pill--secondary____gqHd:hover.pill-module__pill--clickable___ue3SA {
  background: var(--primary50, #f2eff4);
  box-shadow: inset 0px 0px 0px 2px var(--primary600, #4b286d);
}
.pill-module__pill--disabled___zKyPi {
  opacity: 0.5;
  cursor: not-allowed;
}
.pill-module__pill--disabled___zKyPi svg {
  fill: var(--neutral75, #424547);
  stroke: var(--neutral75, #424547);
}
.pill-module__pill--gold___gpcV9, .pill-module__pill--gold___gpcV9:hover.pill-module__pill--clickable___ue3SA {
  background: transparent;
  border: solid 1px var(--gold, #e9b725);
}
.pill-module__pill--gold___gpcV9 svg, .pill-module__pill--gold___gpcV9:hover.pill-module__pill--clickable___ue3SA svg {
  fill: var(--gold, #e9b725);
  stroke: var(--gold, #e9b725);
}
.pill-module__pill--steps-challenge-details___UnqDr {
  margin-top: 10px;
  margin-bottom: 10px;
}
.pill-module__pill--step-1____iiRl {
  margin: 0;
  width: 170px;
}
.pill-module__pill--list-item-cta___guShF {
  padding: 0 10px;
}

.pill-module__label___Eh_fB {
  color: var(--surface1, #fff);
  vertical-align: middle;
  white-space: nowrap;
  width: auto;
}
.pill-module__label--left___QKCRV, .pill-module__label--right___FaQY7 {
  width: calc(100% - 20px);
}
.pill-module__label--outline___f4XZS {
  color: var(--neutral100, #2c2e30);
}
.pill-module__label--outline-blue___wIS5i, .pill-module__label--secondary___K1B6T, .pill-module__label--negative___IPwXM {
  color: var(--primary600, #4b286d);
}
.pill-module__label--disabled___pwnDB {
  color: var(--neutral75, #424547);
}
.pill-module__label--gold___WmHc9, .pill-module__label--list-item-cta___bCVFF {
  color: var(--gold, #e9b725);
}
.pill-module__label--outline-white___O1iNc {
  color: var(--surface1, #fff);
}

.pill-module__active--primary___m5QGA {
  background: var(--primary700, #371e47);
}
.pill-module__active--outline___C4aXY {
  background: var(--primary50, #f2eff4);
  border: solid 2px var(--primary600, #4b286d);
}

.pill-module__icon___NA1ls {
  display: inline-block;
}
.pill-module__icon--left___uocus {
  margin-right: 5px;
}
.pill-module__icon--right___jVMXo {
  margin-left: 5px;
}
.pill-module__icon--bottom___yOuk5, .pill-module__icon--top___oxxhL {
  display: block;
  text-align: center;
}
.pill-module__icon--upside-down___C2ljn {
  transform: rotate(180deg);
  transform-origin: 60% 42%;
}
.pill-module__icon___NA1ls svg {
  vertical-align: middle;
}

.pill-module__spinner___xLoGi {
  width: 18px;
  height: 18px;
  vertical-align: middle;
}
.pill-module__spinner___xLoGi {
  animation: pill-module__spin___QcfMa 0.75s infinite linear;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/well-being/pill/pill.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE;IACE,uBAAA;EAMF;EAJA;IACE,yBAAA;EAMF;AACF;AAHA;EACE,sCAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAKF;AADE;EACE,2BAAA;EACA,6BAAA;AAGJ;AAAE;EACE,mBAAA;AAEJ;AACE;EACE,eAAA;AACJ;AAEE;EACE,mBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,mBAAA;AADJ;AAIE;EACE,eAAA;AAFJ;AAII;EACE,sCAAA;AAFN;AAME;EACE,iCAAA;EACA,kCAAA;AAJJ;AAMI;EACE,gCAAA;EACA,kCAAA;AAJN;AAOI;EACE,qCAAA;EACA,4CAAA;AALN;AASE;EACE,iCAAA;AAPJ;AASI;EACE,gCAAA;EACA,kCAAA;AAPN;AAUI;EACE,4BAAA;AARN;AAYE;EACE,gBAAA;EACA,uCAAA;AAVJ;AAYI;EACE,2BAAA;EACA,6BAAA;AAVN;AAaI;EACE,iCAAA;AAXN;AAYM;EACE,iCAAA;AAVR;AAeE;EACE,iCAAA;EACA,kCAAA;AAbJ;AAeI;EACE,gCAAA;EACA,kCAAA;AAbN;AAgBI;EACE,qCAAA;EACA,4CAAA;AAdN;AAkBE;EACE,iCAAA;EACA,4DAAA;AAhBJ;AAkBI;EACE,gCAAA;EACA,kCAAA;AAhBN;AAmBI;EACE,qCAAA;EACA,4DAAA;AAjBN;AAqBE;EACE,YAAA;EACA,mBAAA;AAnBJ;AAqBI;EACE,+BAAA;EACA,iCAAA;AAnBN;AAuBE;EAEE,uBAAA;EACA,sCAAA;AAtBJ;AAwBI;EACE,0BAAA;EACA,4BAAA;AAtBN;AA0BE;EACE,gBAAA;EACA,mBAAA;AAxBJ;AA2BE;EACE,SAAA;EACA,YAAA;AAzBJ;AA4BE;EACE,eAAA;AA1BJ;;AA8BA;EACE,4BAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AA3BF;AA6BE;EAEE,wBAAA;AA5BJ;AA+BE;EACE,iCAAA;AA7BJ;AAgCE;EAGE,iCAAA;AAhCJ;AAmCE;EACE,gCAAA;AAjCJ;AAoCE;EAEE,2BAAA;AAnCJ;AAsCE;EACE,4BAAA;AApCJ;;AAyCE;EACE,sCAAA;AAtCJ;AAyCE;EACE,qCAAA;EACA,4CAAA;AAvCJ;;AA2CA;EACE,qBAAA;AAxCF;AA0CE;EACE,iBAAA;AAxCJ;AA2CE;EACE,gBAAA;AAzCJ;AA4CE;EAEE,cAAA;EACA,kBAAA;AA3CJ;AA8CE;EACE,yBAAA;EACA,yBAAA;AA5CJ;AA+CE;EACE,sBAAA;AA7CJ;;AAiDA;EAIE,WAAA;EACA,YAAA;EACA,sBAAA;AAjDF;AA4CE;EACE,0DAAA;AA1CJ","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import './../../../styles/utils.scss';\n\n@keyframes :local(spin) {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.pill {\n  background: color(primary600);\n  display: inline-block;\n  padding: 7px 15px 8px;\n  border-radius: 4px;\n  font-size: rem(14);\n  font-weight: 600;\n\n  // default svg colors - overridden by the svg specifying\n  // 'none' when it does not need it\n  svg {\n    fill: color(surface1);\n    stroke: color(surface1);\n  }\n\n  &--round {\n    border-radius: 21px;\n  }\n\n  &--large {\n    font-size: rem(16);\n  }\n\n  &--medium {\n    font-size: rem(14);\n  }\n\n  &--padded {\n    padding-left: $spacing * 1.5;\n    padding-right: $spacing * 1.5;\n  }\n\n  &--clickable {\n    cursor: pointer;\n\n    &:hover {\n      background: color(primary700);\n    }\n  }\n\n  &--outline {\n    background: color(surface1);\n    border: solid 1px color(neutral15);\n\n    svg {\n      fill: color(neutral100);\n      stroke: color(neutral100);\n    }\n\n    &:hover.pill--clickable {\n      background: color(primary50);\n      border: solid 2px color(primary600);\n    }\n  }\n\n  &--negative {\n    background: color(surface1);\n\n    svg {\n      fill: color(primary600);\n      stroke: color(primary600);\n    }\n\n    &:hover.pill--clickable {\n      background: color(neutral15);\n    }\n  }\n\n  &--outline-white {\n    background: none;\n    border: solid 2px color(surface1);\n\n    svg {\n      fill: color(surface1);\n      stroke: color(surface1);\n    }\n\n    &:hover.pill--clickable {\n      background: color(surface1);\n      .label {\n        color: color(primary600);\n      }\n    }\n  }\n\n  &--outline-blue {\n    background: color(surface1);\n    border: solid 1px color(neutral15);\n\n    svg {\n      fill: color(primary600);\n      stroke: color(primary600);\n    }\n\n    &:hover.pill--clickable {\n      background: color(primary50);\n      border: solid 2px color(primary600);\n    }\n  }\n\n  &--secondary {\n    background: color(surface1);\n    box-shadow: inset 0px 0px 0px 2px color(primary600);\n\n    svg {\n      fill: color(neutral100);\n      stroke: color(neutral100);\n    }\n\n    &:hover.pill--clickable {\n      background: color(primary50);\n      box-shadow: inset 0px 0px 0px 2px color(primary600);\n    }\n  }\n\n  &--disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n\n    svg {\n      fill: color(neutral75);\n      stroke: color(neutral75);\n    }\n  }\n\n  &--gold,\n  &--gold:hover.pill--clickable {\n    background: transparent;\n    border: solid 1px color(gold);\n\n    svg {\n      fill: color(gold);\n      stroke: color(gold);\n    }\n  }\n\n  &--steps-challenge-details {\n    margin-top: 10px;\n    margin-bottom: 10px;\n  }\n\n  &--step-1 {\n    margin: 0;\n    width: 170px;\n  }\n\n  &--list-item-cta {\n    padding: 0 10px;\n  }\n}\n\n.label {\n  color: color(surface1);\n  vertical-align: middle;\n  white-space: nowrap;\n  width: auto;\n\n  &--left,\n  &--right {\n    width: calc(100% - 20px);\n  }\n\n  &--outline {\n    color: color(neutral100);\n  }\n\n  &--outline-blue,\n  &--secondary,\n  &--negative {\n    color: color(primary600);\n  }\n\n  &--disabled {\n    color: color(neutral75);\n  }\n\n  &--gold,\n  &--list-item-cta {\n    color: color(gold);\n  }\n\n  &--outline-white {\n    color: color(surface1);\n  }\n}\n\n.active {\n  &--primary {\n    background: color(primary700);\n  }\n\n  &--outline {\n    background: color(primary50);\n    border: solid 2px color(primary600);\n  }\n}\n\n.icon {\n  display: inline-block;\n\n  &--left {\n    margin-right: calc($spacing / 4);\n  }\n\n  &--right {\n    margin-left: calc($spacing / 4);\n  }\n\n  &--bottom,\n  &--top {\n    display: block;\n    text-align: center;\n  }\n\n  &--upside-down {\n    transform: rotate(180deg);\n    transform-origin: 60% 42%;\n  }\n\n  svg {\n    vertical-align: middle;\n  }\n}\n\n.spinner {\n  :local {\n    animation: spin 0.75s infinite linear;\n  }\n  width: 18px;\n  height: 18px;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pill": `pill-module__pill___HvBPl`,
	"pill--round": `pill-module__pill--round___Dbavy`,
	"pill--large": `pill-module__pill--large___Frv60`,
	"pill--medium": `pill-module__pill--medium___qeV_2`,
	"pill--padded": `pill-module__pill--padded___uRqRv`,
	"pill--clickable": `pill-module__pill--clickable___ue3SA`,
	"pill--outline": `pill-module__pill--outline___aUVll`,
	"pill--negative": `pill-module__pill--negative___pIav7`,
	"pill--outline-white": `pill-module__pill--outline-white___f7vm8`,
	"label": `pill-module__label___Eh_fB`,
	"pill--outline-blue": `pill-module__pill--outline-blue___ns8Ky`,
	"pill--secondary": `pill-module__pill--secondary____gqHd`,
	"pill--disabled": `pill-module__pill--disabled___zKyPi`,
	"pill--gold": `pill-module__pill--gold___gpcV9`,
	"pill--steps-challenge-details": `pill-module__pill--steps-challenge-details___UnqDr`,
	"pill--step-1": `pill-module__pill--step-1____iiRl`,
	"pill--list-item-cta": `pill-module__pill--list-item-cta___guShF`,
	"label--left": `pill-module__label--left___QKCRV`,
	"label--right": `pill-module__label--right___FaQY7`,
	"label--outline": `pill-module__label--outline___f4XZS`,
	"label--outline-blue": `pill-module__label--outline-blue___wIS5i`,
	"label--secondary": `pill-module__label--secondary___K1B6T`,
	"label--negative": `pill-module__label--negative___IPwXM`,
	"label--disabled": `pill-module__label--disabled___pwnDB`,
	"label--gold": `pill-module__label--gold___WmHc9`,
	"label--list-item-cta": `pill-module__label--list-item-cta___bCVFF`,
	"label--outline-white": `pill-module__label--outline-white___O1iNc`,
	"active--primary": `pill-module__active--primary___m5QGA`,
	"active--outline": `pill-module__active--outline___C4aXY`,
	"icon": `pill-module__icon___NA1ls`,
	"icon--left": `pill-module__icon--left___uocus`,
	"icon--right": `pill-module__icon--right___jVMXo`,
	"icon--bottom": `pill-module__icon--bottom___yOuk5`,
	"icon--top": `pill-module__icon--top___oxxhL`,
	"icon--upside-down": `pill-module__icon--upside-down___C2ljn`,
	"spinner": `pill-module__spinner___xLoGi`,
	"spin": `pill-module__spin___QcfMa`
};
export default ___CSS_LOADER_EXPORT___;
